import React from 'react';
import {FieldArray, useFormikContext} from 'formik';
import {filter, findIndex} from 'lodash';
import BaseStep from 'high-school-student/account-conversion/components/base-step';
import AchievementCards from 'shared/registration/components/achievement-cards';
import {ImpactFactorQuestion, ImpactFactor, Answer} from '../types';

const impactFactorAnswer = (factor: ImpactFactor, questionId: string): Answer => ({
  questionId,
  identifier: factor.name,
  content: '',
});

interface AchievementCardOption {
  name: string;
  questionId: string;
}

const answersForQuestion = (answers: Answer[], questionId: string): AchievementCardOption[] =>
  filter(answers, {questionId}).map(
    ({identifier}: Answer): AchievementCardOption => ({
      name: identifier,
      questionId,
    })
  );

const ImpactFactors = (props: {question: ImpactFactorQuestion}): React.ReactElement => {
  const {values} = useFormikContext<{answers: Answer[]}>();

  return (
    <BaseStep stepHeader={props.question.text} subHeader={props.question.subheading}>
      <FieldArray name="answers">
        {(arrayHelpers): React.ReactElement => (
          <AchievementCards
            userSelectedItems={answersForQuestion(values.answers, props.question._id)}
            size="medium"
            saveItem={(factor): void =>
              arrayHelpers.push(impactFactorAnswer(factor, props.question._id))
            }
            removeItem={({name}): void =>
              arrayHelpers.remove(
                findIndex(values.answers, {questionId: props.question._id, identifier: name})
              )
            }
            items={props.question.impactFactors}
            trackPrefix="survey-impact-factors"
          />
        )}
      </FieldArray>
    </BaseStep>
  );
};

export default ImpactFactors;
